import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useCallback, useMemo } from 'react';
import { IKPIRequestDataModel } from '../../../../../data-models/kpi-requests.data-model';
import { KpiAction } from '../../../../../services/state/KPI/KPIRequestsStateJ';
import { MenuButton } from '../../../../Finance2/common-grid-defs/MenuButton';
import { useRequestActions } from '../KPIRequestResponse/hooks/useKPIRequestResponseActions';
import { PermissionService } from '../../../../../services/PermissionService';
import { PermissionKey } from '../../../../../services/PermissionAndRolesKeys';

export const MoreRequestActionsTitle = 'More Options';

export function useSelectDeleteRequest() {
  const { onSelectAction } = useRequestActions();
  return useCallback(
    (data: IKPIRequestDataModel) => {
      onSelectAction(data, KpiAction.archive);
    },
    [onSelectAction]
  );
}

export function useDeleteRequestMenuItem({ request }: { request?: IKPIRequestDataModel }) {
  const onDeleteRequest = useSelectDeleteRequest();

  return useMemo(
    () => ({
      name: 'Delete',
      icon: <DeleteOutlineOutlinedIcon />,
      onClick: () => {
        if (!request?.id) {
          return;
        }
        onDeleteRequest(request);
      },
    }),
    [onDeleteRequest, request]
  );
}

export function MoreRequestOptionsButton({ request }: { request?: IKPIRequestDataModel }) {
  const deleteRequestMenuItem = useDeleteRequestMenuItem({ request });

  const moreOptions = useMemo(() => {
    if (!request) {
      return [];
    }
    return [deleteRequestMenuItem];
  }, [deleteRequestMenuItem, request]);

  if (!PermissionService.get().hasPermission(PermissionKey.canWriteDataCollection)) {
    return null;
  }

  return <MenuButton menuItems={moreOptions} label={MoreRequestActionsTitle} />;
}
